import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import React from "react";
import "./style.scss";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
const CustomModal = ({ open, handleClose, children,className }) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className={className}>{children}</Box>
      </Modal>
    </div>
  );
};

export default CustomModal;
